export default __webpack_public_path__ + "static/media/third_img.baf56c33.svg";